// Module
var code = "<h2 id=\"looking-for-a-form\">Looking for a Form?</h2> <p>Visit our forms page for private and federal loan documents and other account-related forms. </p> ";
// Exports
export default code;